export const findContentByLabel = (data, label) => {
  if (!data || !Array.isArray(data)) return ""
  return data.find((item) => item.label === label)?.content
}
